import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import Video from '../../../../components/Video';

/** @type import('@contentful/rich-text-react-renderer').NodeRenderer */
export default function EmbeddedAsset(node) {
  if (node.data.target.gatsbyImageData) {
    return (
      <GatsbyImage
        alt={node.data.target.description}
        image={node.data.target.gatsbyImageData}
        loading="lazy"
      />
    );
  }
  if (node.data.target.mimeType.startsWith('video/')) {
    return (
      <Video
        description={node.data.target.description}
        url={node.data.target.url}
      />
    );
  }
  return null;
}
